/* global game, CocoonJS */

Game.States.LoadWorld = {

	params: null,

	init: function( params ) {

		this.params = [];

		if ( params ) {
			this.params = params;
			this.params.slug = Game.Utils.Map.map_slug( this.params.path );

			console.log( this.params );
		}

	},

	preload: function() {

		// Add a progress bar
		var progressBar = game.add.sprite( game.world.centerX, game.world.centerY, 'progressBar' );
		progressBar.anchor.setTo( 0.5, 0.5 );
		game.load.setPreloadSprite( progressBar );

		this.load.path = '/assets/games/star-raid/';

		// Check if the file has already been loaded so we don't load it again.
		if ( !game.cache.checkTilemapKey( this.params.slug ) ) {

			var path = 'levels/' + this.params.path + '.json';

			game.load.tilemap( this.params.slug, path, null, Phaser.Tilemap.TILED_JSON );

			console.log( 'load map:', this.params.slug, path );

		}

	},

	create: function() {

		game.state.start( 'world', true, false, this.params );

	},

};
